import {ym} from './ym'
import {getAnalyticsId} from './getAnalyticsId'

/**
 * https://yandex.ru/support/metrica/objects/extlink.html
 * Некоторые внешние переходы у нас происходят программно через window.open, поэтому патчим его что отслеживать вызовы
 */
try {
  const originalOpen = window.open

  window.open = (href, ...rest) => {
    try {
      if (href && String(href).includes(window.location.hostname) === false) {
        ym(getAnalyticsId(), 'extLink', String(href))
      }
    } catch (error) {
      console.error(error)
    }

    return originalOpen(href, ...rest)
  }
} catch (error) {
  console.error(error)
}
